export default "__VITE_ASSET__pi$V7Zsj__"